export enum BusinessSector {
  ItSoftware = 'ItSoftware',
  ItHardware = 'ItHardware',
  ItServices = 'ItServices',
  Retail = 'Retail',
  FinanceBanking = 'FinanceBanking',
  FinanceInsurance = 'FinanceInsurance',
  FinanceInvestmentManagement = 'FinanceInvestmentManagement',
  Healthcare = 'Healthcare',
  BusinessProfessionalServices = 'BusinessProfessionalServices',
  Energy = 'Energy',
  Telecommunications = 'Telecommunications',
  Utilities = 'Utilities',
  TourismHospitality = 'TourismHospitality',
  Manufacturing = 'Manufacturing',
  Pharmaceuticals = 'Pharmaceuticals',
  DefenseMilitaryContractor = 'DefenseMilitaryContractor',
  EntertainmentMedia = 'EntertainmentMedia',
  TransportationAviationAerospace = 'TransportationAviationAerospace',
  PublicAuthorityNgosNonProfit = 'PublicAuthorityNgosNonProfit',
  RealEstatePropertyConstruction = 'RealEstatePropertyConstruction',
  Education = 'Education',
  MiningPrimaryIndustries = 'MiningPrimaryIndustries',
  FoodAndAgriculture = 'FoodAndAgriculture',
  Other = 'Other',
}

export const BusinessSectorDescriptor = Object.freeze({
  [BusinessSector.ItSoftware]: 'IT - Software',
  [BusinessSector.ItHardware]: 'IT - Hardware',
  [BusinessSector.ItServices]: 'IT - Services',
  [BusinessSector.Retail]: 'Retail',
  [BusinessSector.FinanceBanking]: 'Finance Banking',
  [BusinessSector.FinanceInsurance]: 'Finance Insurance',
  [BusinessSector.FinanceInvestmentManagement]: 'Finance Investment Management',
  [BusinessSector.Healthcare]: 'Healthcare',
  [BusinessSector.BusinessProfessionalServices]: 'Business & Professional Services',
  [BusinessSector.Energy]: 'Energy',
  [BusinessSector.Telecommunications]: 'Telecommunications',
  [BusinessSector.Utilities]: 'Utilities',
  [BusinessSector.TourismHospitality]: 'Tourism & Hospitality',
  [BusinessSector.Manufacturing]: 'Manufacturing',
  [BusinessSector.Pharmaceuticals]: 'Pharmaceuticals',
  [BusinessSector.DefenseMilitaryContractor]: 'Defense / Military Contractor',
  [BusinessSector.EntertainmentMedia]: 'Entertainment & Media',
  [BusinessSector.TransportationAviationAerospace]: 'Transportation / Aviation / Aerospace',
  [BusinessSector.PublicAuthorityNgosNonProfit]: 'Public Authority; NGOs; Non-Profit',
  [BusinessSector.RealEstatePropertyConstruction]: 'Real Estate, Property & Construction',
  [BusinessSector.Education]: 'Education',
  [BusinessSector.MiningPrimaryIndustries]: 'Mining & Primary Industries',
  [BusinessSector.FoodAndAgriculture]: 'Food & Agriculture',
  [BusinessSector.Other]: 'Other',
});
